<template>
  <div>
    <RouterLink to="/accessiblity">
      <button id="btn-access" class="mt-10 lg:mt-12 white-btnx text-btnhome-mob lg:text-btnhome rounded-50px text-purple bg-white border-3px border-purple inline-flex gap-x-4 py-2 lg:py-4 px-7 hover:text-white hover:bg-purple group items-center">
        <img src="@/assets/img/icons/settings.svg" alt="" class="w-6 lg:w-30px group-hover:hidden">
        <img src="@/assets/img/icons/settings-white.svg" alt="" class="w-6 lg:w-30px hidden group-hover:inline-block">
        {{ name }}</button>
    </RouterLink>
  </div>
</template>

<script>
export default {
  name: 'SettingsButton',
  props: {
    name: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

// .white-btn{
//   // font-family: "Outfit", sans-serif;
//   font-size: 1.5rem;
//   padding: 10px 20px;
//   padding-right: 40px;
//   border-radius: 50px;
//   color: #612B78 !important;
//   background-color: white !important;
//   border: 3px solid #612B78 !important;
// }

// .white-btn:hover{
//   color: white !important;
//   background-image: none;
//   background-color: #612B78 !important;
// }

// .white-btn::before{
//   content: '\f013';
//     font-family: FontAwesome;
//     font-style: normal;
//     font-weight: normal;
//     text-decoration: inherit;
//     margin-right:20px;
//     color:#612B78;
// }

// .white-btn:hover::before{
//   content: '\f013';
//     color: white;
// }

</style>
